import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_7: FaireProductEntity = {
  token: "atc_fs_7",
  type: "product",
  name: "0.4 Clean Girl Solid Perfume",
  brandName: "Tenth Muse",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4a6c774f57af8f42fd41a0e4eba5dcf3d1f60cdc2b777557da6148ddfc5021fe.webp",
  priceDollars: 22,
  msrpDollars: 44,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
